import React, {useEffect, useState} from 'react';
import './forumsRegistrationForm.scss'
import {SubmitHandler, useForm} from "react-hook-form";
import {baseUrl} from "../../../../../constants/constants";
import {useAuth} from "../../../../../components/authProvider/authProvider";
import axios, {AxiosError} from "axios";
import {toast} from "react-toastify";
import './forumsRegistrationForm.scss'
export function checkErrorText(inputName: string, errors: any) {
    return errors?.[inputName] && errors?.[inputName]?.message;
}

interface Form {
    id: number,
    email: string,
    full_name: string,
    number_phone: string,
    region_residence: string,
    place_of_work: string,
    position_work: string,
    custom_position: string,
    travel_certificate: boolean,
    is_mailing: boolean
    visit_format_id: number,
    date_creation: Date,
    questions: string,
    educational_organization_id: number | null
}

interface Props {
    id: number,
    close: () => void,
    forum_visit_format: any[],
    educational_organization_id: any[],
}

const copyOnlyLive = (object: any) => {
    const copy = {};

    Object.keys(object).forEach((key: string) => {
        if (object[key] === null || object[key] === undefined) {
            return;
        }
        //@ts-ignore
        copy[key] = object[key];
    })

    return copy;
}


const RegistrationForm = ({id, close, forum_visit_format, educational_organization_id}: Props) => {
    const isAuth = useAuth()
    const [metrikaCounted, setMetrikaCounted] = React.useState(false)
    const [selectedPosition, setSelectedPosition] = useState<string>('');

    const handleRegister = () => {
        if (!metrikaCounted) {
            setMetrikaCounted(true)
            // @ts-ignore
            ym(100105951,'reachGoal','forums-register')
        }
    }

    const {
        register,
        handleSubmit,
        formState: {errors},
        setError,
        watch,
        setValue,
    } = useForm<Form>({
        defaultValues: {
            is_mailing: true
        }
    });

    const positionWorkSelect = watch('position_work');

    useEffect(() => {
        setSelectedPosition(positionWorkSelect);
    }, [positionWorkSelect]);

    // const [orgList, setOrgList] = useState<Array<{ id: number, name: string }>>([]);

    // useEffect(() => {
    //     axios.get(`${baseUrl}educational_organization`)
    //         .then((res) => res.data)
    //         .then(d => {
    //             setOrgList(d);
    //             setValue('educational_organization_id', null)
    //         })
    // }, []);

    // const {visit_format_id} = watch();

    // useEffect(() => {
    //     if (forum_visit_format.find(f => f.id == visit_format_id)?.name === 'online') {
    //         setValue('educational_organization_id', null)
    //     } else {
    //         setValue('educational_organization_id', 1)
    //     }
    // }, [visit_format_id, forum_visit_format])

    const submit: SubmitHandler<Form> = async (data) => {
        const finalData = {
            ...data,
            position_work:
                data.position_work === 'Другое' && data.custom_position
                    ? data.custom_position
                    : data.position_work,
        };
        toast.promise(
            new Promise((res, rej) => {
                axios.post(`${baseUrl}blank_forum`, {
                    ...copyOnlyLive(finalData),
                    forum_id: id
                })
                    .then((e) => {
                        res('ok');
                        handleRegister()
                        localStorage.setItem('form', 'accepted');
                    })
                    .catch((e) => {
                        const ae = e as AxiosError

                        if (ae.status === 401) {
                            setError('root', {type: 'custom', message: ''});
                            rej('error')
                            return;
                        }
                        if (ae.status === 409) {
                            setError('root', {type: 'repeatRequest', message: 'Вы отправили повторную заявку'})
                            rej('error')
                            return;
                        }
                    })
            }),
            {
                'pending': 'Отправление заявки на регистрацию',
                'success': 'Заявка успешно отправлена',
                'error': 'Вы ранее направляли заявку на форум. Для редактирования заявки обратитесь к администраторам сайта по электронной почте info@ncpti.ru или по номеру телефона +7(863)201-28-22'
            },
            {
                autoClose: false
            }
        ).then(() => {
            setTimeout(() => {
                close();
            }, 1000)
        }).catch(() => {

        })
    }

    return (
        <form
            onSubmit={handleSubmit(submit)}
            className='forum_form'
        >
            <input
                type="text"
                placeholder='ФИО'
                className='forum_form_input'
                {...register('full_name',
                    {required: true, value: isAuth?.authState.user?.full_name})}/>
            {errors.full_name && <p className='wrong-message'>Это поле обязательно</p>}

            <input
                type="text"
                placeholder='Субъект России'
                className='forum_form_input'
                {...register('region_residence',
                    {required: true,})}/>
            {errors.region_residence && <p className='wrong-message'>Это поле обязательно</p>}

            <input
                type="text"
                placeholder='Место работы'
                className='forum_form_input'
                {...register('place_of_work',
                    {
                        required: true,
                        value: isAuth?.authState.user?.place_of_work
                    })}/>
            {errors.place_of_work && <p className='wrong-message'>Это поле обязательно</p>}

            <label className='forum_form_label'>
                Должность:
                <select
                    id="position-work"
                    {...register('position_work', {required: true})}
                    onChange={(e) => {
                        const value = e.target.value;
                        setValue('position_work', value);
                        setSelectedPosition(value);
                    }}
                >
                    <option value="Проректор по воспитательной работе и молодежной политике">Проректор по воспитательной работе и молодежной политике</option>
                    <option value="Директор координационного центра">Директор координационного центра</option>
                    <option value="Специалист координационного центра">Специалист координационного центра</option>
                    <option value="Руководитель подразделения по воспитательной работе / молодежной политике">Руководитель подразделения по воспитательной работе / молодежной политике</option>
                    <option value="Специалист подразделения по воспитательной работе / молодежной политике">Специалист подразделения по воспитательной работе / молодежной политике</option>
                    <option value="Другое">Другое</option>
                </select>
            </label>

            {selectedPosition === 'Другое' && (
                <>
                    <label
                        style={{marginTop:'0'}}
                        className={'forum_form_label'}
                    >
                        Если другое, напишите должность:
                    <input
                        type="text"
                        placeholder='Укажите должность'
                        className={`forum_form_input`}
                        defaultValue={isAuth?.authState.user?.position_work}
                        style={{marginTop:'.3rem'}}
                        {...register('custom_position', {
                            required: selectedPosition === 'Другое',
                            validate: value => value !== 'Другое' || 'Введите корректное значение'
                        })}
                    />
                    {errors.position_work && <p className='wrong-message'>Обязательное поле</p>}
                    </label>
                </>
            )}

            <input
                type="text"
                placeholder='Контактный номер телефона'
                className='forum_form_input'
                defaultValue={isAuth?.authState.user?.number_phone == null ? '+7' : `+${isAuth?.authState.user?.number_phone}`}
                {...register('number_phone',
                    {
                        required: true,
                        validate: {validatePhone: (v) => /\+7\d{3}\d{3}\d{2}\d{2}/.test(v) || 'Введите номер телефона, начиная с +7'}
                    })}
            />
            {errors.number_phone && <p className='wrong-message'>{checkErrorText('number_phone', errors)}</p>}
            {errors.number_phone && <p className='wrong-message'>Это поле обязательно</p>}

            <input
                type="text"
                placeholder='Электронная почта'
                className='forum_form_input'
                {...register('email',
                    {
                        required: true,
                        value: isAuth?.authState.user?.email
                    })}/>
            {errors.email && <p className='wrong-message'>Это поле обязательно</p>}

            <input
                type="text"
                defaultValue={'2'}
                {...register('visit_format_id')}
                style={{opacity: '0', position: 'absolute'}}
            />

            <textarea
                placeholder='Ответы на какие вопросы вы бы хотели получить'
                className='forum_form_input'
                {...register('questions')}
            />

            <span className='forum_form_input_checkbox'>
                    <input type="checkbox" className='forum_form_input_checkbox_galka' {...register('travel_certificate')}/>
                    <label htmlFor='comandirovochnoe'>Нужно подписать командировочные</label>
            </span>

            <span className='forum_form_input_checkbox'>
                    <label htmlFor='comandirovochnoe'>Отправляя заявку на форум, вы соглашаетесь получать уведомления и рассылку по мероприятию</label>
            </span>

            <button className="button form-btn">Отправить</button>
            {/*{errors.root && <p className='wrong-message'>{checkErrorText('travel_certificate', errors)}</p>}*/}
            {errors.root && <p className='wrong-message'>Вы уже отправляли заявку на мероприятие</p>}
        </form>
    );
};

export default RegistrationForm;

{/*<label className='regLabel'>*/}
{/*    Форма участия:*/}
{/*    <select*/}
{/*        id="form-of-participation"*/}
{/*        // disabled={disabled}*/}
{/*        {...register('visit_format_id', {required: true})}*/}
{/*    >*/}
{/*        /!* {forum_visit_format[0]?.name === 'online' ?*/}
{/*            <option value='1'>Онлайн</option> :*/}
{/*            forum_visit_format[0]?.name === 'offline' ?*/}
{/*                <option value='2'>Очно</option> : ''*/}
{/*        }*/}
{/*        {forum_visit_format[1]?.name === 'online' ?*/}
{/*            <option value='1'>Онлайн</option> :*/}
{/*            forum_visit_format[1]?.name === 'offline' ?*/}
{/*                <option value='2'>Очно</option> : ''*/}
{/*        }*!/*/}
{/*        {*/}
{/*            forum_visit_format.map(item => (*/}
{/*                <option value={item.id} key={item.id}>*/}
{/*                    {item.name === 'online' ? 'Онлайн' : 'Очно'}*/}
{/*                </option>*/}
{/*            ))*/}
{/*        }*/}
{/*    </select>*/}
{/*</label>*/}
{/*{*/}
{/*    visit_format_id == 2 &&*/}
{/*    <label className='regLabel'>*/}
{/*        Категория участия:*/}
{/*        <select*/}
{/*            id="form-of-participation"*/}
{/*            // disabled={disabled}*/}
{/*            {...register('educational_organization_id', {required: true})}*/}
{/*        >*/}
{/*            {*/}
{/*                orgList.map((d) => (*/}
{/*                    <option value={d.id} key={d.id}>*/}
{/*                        {d.name}*/}
{/*                    </option>*/}
{/*                ))*/}
{/*            }*/}
{/*        </select>*/}
{/*    </label>*/}
{/*}*/}